import classNames from 'classnames'
import { Component, ReactNode } from 'react'
import { toast } from 'react-toastify'
import {
  ListNoteTopicResponseDto,
  MiscNoteFieldDto,
  NewNoteTopicDto,
  NoteTopicDto
} from '../../../../definition/notes.dto'
import { processLoading } from '../../../../initialization'

import { asyncCreateTopic, asyncDeleteNoteTopic, asyncSaveTopic } from '../../../../services/notes.service'
import { ModalNodeProps } from '../../../components/modal.component'
import PaddingComponent from '../../../components/paging.component'
import { EditField } from './edit-fields'
import { EditTopic } from './edit-topic'

const limit = 10

export interface NoteTopicsState {
  selectedPage: number
  numberDisplayedIndex: number
  totalPage: number

  selectedTopic?: NoteTopicDto // The selected Topic
  noteTopics?: NoteTopicDto[]

  miscNoteId?: string
  fields?: MiscNoteFieldDto[] // The Fields

  loadNoteTopics: (searchData?: { selectedPage?: number }) => Promise<ListNoteTopicResponseDto>

  selectedTopicAndFields: (topicId: string, fields: MiscNoteFieldDto[]) => void
}

export class NoteTopicsModal extends Component<ModalNodeProps, NoteTopicsState> {
  constructor(props: any) {
    super(props)
    const data = this.props.input
    this.state = {
      miscNoteId: data.miscNoteId,
      fields: data.fields,
      selectedTopic: undefined,

      noteTopics: [],
      loadNoteTopics: data.loadNoteTopics,
      selectedTopicAndFields: data.selectedTopicAndFields,

      selectedPage: 0,
      totalPage: 1,
      numberDisplayedIndex: limit
    }
  }

  componentDidMount() {
    this.doInit()
  }

  async doInit() {
    await processLoading(this.processInit())
  }

  async processInit() {
    const topics = await this.state.loadNoteTopics()

    if (topics) {
      const totalPage = Math.floor(((topics.count || 0) - 1) / limit) + 1
      this.setState({
        noteTopics: topics.items,
        totalPage: totalPage
      })
    }
  }

  async doDelete() {
    await processLoading(this.processInit())
  }

  async processDelete(id: string) {
    try {
      await asyncDeleteNoteTopic(id)
      const topics = await this.state.loadNoteTopics({
        selectedPage: this.state.selectedPage
      })

      if (topics) {
        const totalPage = Math.floor(((topics.count || 0) - 1) / limit) + 1
        this.setState({
          noteTopics: topics.items,
          totalPage: totalPage
        })
      }
    } catch (error: any) {
      let errorMessage =
        error?.response?.status >= 500 ? (
          <>
            Can not process the deletion!.
            <br />
            Maybe note have the related data, so we can not delete it.
            <br />
            Please contact with admin developer for get more detail!
          </>
        ) : (
          error.response?.data?.error?.message || error.message
        )
      toast.error(errorMessage)
    }
  }

  onNewNoteTopic = async (dto: NewNoteTopicDto) => {
    try {
      await asyncCreateTopic(dto)

      const topics = await this.state.loadNoteTopics()

      if (topics) {
        const totalPage = Math.floor(((topics.count || 0) - 1) / limit) + 1
        this.setState({
          noteTopics: topics.items,
          totalPage: totalPage,
          selectedTopic: undefined
        })
      }
    } catch (error: any) {
      const errMsg = error.response?.data?.error?.message || error.message
      console.error(errMsg)
      toast.error(<>{errMsg}</>)
    }
  }

  onSaveNoteTopic = async (dto: NoteTopicDto) => {
    try {
      await asyncSaveTopic(dto)
      const topics = await this.state.loadNoteTopics()

      if (topics) {
        const totalPage = Math.floor(((topics.count || 0) - 1) / limit) + 1
        this.setState({
          noteTopics: topics.items,
          totalPage: totalPage,
          selectedTopic: undefined
        })
      }
    } catch (error: any) {
      const errMsg = error.response?.data?.error?.message || error.message
      console.error(errMsg)
      toast.error(<>{errMsg}</>)
    }
  }

  onChooseAndBack = () => {
    if (!this.state.selectedTopic?.id || !this.state.fields) {
      toast.warn(<>You must choose a topic first!</>)
      return
    }
    this.state.selectedTopicAndFields(this.state.selectedTopic?.id, this.state.fields)
    this.props.onDone?.()
  }

  render(): ReactNode {
    return (
      <div className='note-topic-choose'>
        <div className='note-topic-list-modal'>
          <div className='left-panel'>
            <div className='list'>
              <div className='header'>
                <span className='column f4'>Topic Name</span>
                <span className='column f1 action'></span>
              </div>
              {(this.state.noteTopics || []).map((topic) => (
                <div
                  className={classNames('row', {
                    selected: this.state.selectedTopic?.id === topic.id
                  })}
                  key={topic.id}
                  onClick={() => {
                    this.setState({
                      selectedTopic: topic
                    })
                  }}
                >
                  <span className='column f4'>{topic.name}</span>
                  <div className='column f1 action'>
                    <div
                      className='del-btn'
                      onClick={(event) => {
                        event.stopPropagation()
                        event.preventDefault()
                        this.processDelete(topic.id)
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <PaddingComponent
              selectedPage={this.state.selectedPage}
              totalPage={this.state.totalPage}
              numberDisplayedIndex={this.state.numberDisplayedIndex}
              onSelectIndex={async (index) => {
                const data = await this.state.loadNoteTopics({
                  selectedPage: index
                })
                this.setState({
                  selectedPage: index,
                  noteTopics: data.items,
                  selectedTopic: undefined
                })
              }}
              className='quote-page-paging'
            />
          </div>

          <div className='right-panel'>
            <EditTopic
              topic={this.state.selectedTopic}
              onNewCb={async (newItem: NoteTopicDto) => {
                const data = await this.state.loadNoteTopics({
                  selectedPage: 0
                })
                this.setState({
                  noteTopics: data.items,
                  selectedTopic: data.items.find((item) => item.id === newItem.id),
                  selectedPage: 0
                })
              }}
              onSaveCb={async (newItem: NoteTopicDto) => {
                const data = await this.state.loadNoteTopics({
                  selectedPage: this.state.selectedPage
                })
                this.setState({
                  noteTopics: data.items,
                  selectedTopic: data.items.find((item) => item.id === newItem.id)
                })
              }}
              removeSelected={() => {
                this.setState({
                  selectedTopic: undefined
                })
              }}
            />

            <EditField fields={this.state.fields} onSaveCb={() => {}} />
          </div>
        </div>
        <div className='action-button column'>
          <button className='primary' onClick={this.onChooseAndBack}>
            Choose & Back
          </button>
        </div>
      </div>
    )
  }
}
